import { parseRuntime, ruleEngineRequest } from './impl-helper';

export const getUdpFactRender = async (params, almanac) => {
    const { variable, current } = await parseRuntime(params, almanac);
    const factInfo = current.node.data.factInfo;
    const encode = factInfo.props.encode || '';
    let result = false;
    if (variable?.UID > 0) {
        console.log('udp-fact', factInfo);
        try {
            const { isTarget } = await ruleEngineRequest('udp-container', 'isTargetUser', {
                encodeContent: encode
            }, variable);
            result = isTarget;
        } catch (error) {
            //调用失败，默认为false
            console.error('udp-fact request fail', encode, error);
        }
    }
    if (current.port.id === 'udp-a-port') {
        return result;
    } else if (current.port.id === 'udp-b-port') {
        return !result;
    }
    return false;
};
